import React, { Component } from 'react';
import {
  Row,
  Col,
  HeadingText,
  Sheet,
  v2blue400,
  Link,
} from '@paypalcorp/pp-react';
import styles from './hubFeaturedCharityContainer.less';
import SelectedFeaturedCharity from '../selectFeaturedCharity/selectFeaturedCharity';
import HubCharityCard from '../hubFeaturedCharityCard/hubCharityCard';
import { scroller } from 'react-scroll';
import * as analytics from '../../lib/analytics';
import MediaQuery from 'react-responsive';

export default class FeaturedCharityContainer extends Component {
  constructor(props) {
    super(props);
    let showSelectedCharity = props.selectedCharityIndexOnRedirect !== -1;
    this.state = {
      selectedCharity: showSelectedCharity,
      selectedIndex: props.selectedCharityIndexOnRedirect,
      showFeaturedCharities: !showSelectedCharity,
      preferredCharityNpid: this.props.preferredCharityNpid,
      seeMore: false,
      showToastPreferredMessage: Boolean(showSelectedCharity),
    };
  }

  componentDidMount() {
    const { authState } = JSON.parse(
      document.getElementById('data-props').innerHTML
    );

    const { country: contentCountry } = JSON.parse(
      document.getElementById('data-locale').innerHTML
    );
    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_LOADED, {
      e: 'av',
      item_name: 'dw_giving',
      scope: 'module',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      module: 'charity',
      acct_cntry: contentCountry,
      card_type: 'charity_featured',
      tile_id: 'HubFeatureCharity',
      lcid: '-', // TODO Check how to get the lcid
      order: 1,
      state: 'loaded',
    });

    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_SHOWN, {
      e: 'im',
      item_name: 'dw_giving',
      scope: 'module',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      module: 'charity',
      acct_cntry: contentCountry,
      card_type: 'charity_featured',
      tile_id: 'HubFeatureCharity',
      lcid: '-', // TODO Check how to get the lcid
      order: 1,
      state: 'populated',
    });
  }

  handleCharityClick(charity, index) {
    const { authState } = JSON.parse(
      document.getElementById('data-props').innerHTML
    );
    const { country: contentCountry } = JSON.parse(
      document.getElementById('data-locale').innerHTML
    );
    analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_PRESSED, {
      e: 'cl',
      item_name: 'dw_giving',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      state: 'populated',
      link_name: 'card',
      scope: 'tile',
      module: 'charity',
      tile_id: charity.nonprofit_id,
      card_type: 'charity',
      tile_id_type: 'crid',
      charityName: charity.name || '',
      acct_cntry: contentCountry,
      lcid: '-', // TODO Check how to get the lcid
      order: 1,
    });

    this.setState({
      selectedCharity: true,
      selectedIndex: index,
      showFeaturedCharities: false,
    });
    this.handleAnalyticsClick(charity, 'charity');
    scroller.scrollTo('searchContainer', {
      delay: 0,
      duration: 0,
    });
  }

  handleAnalyticsClick(charity, linkname) {
    analytics.trackLinkWithData(
      linkname,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: charity.nonprofit_id },
      'link'
    );
  }

  handleBackNavigation() {
    this.setState({
      selectedCharity: false,
      showFeaturedCharities: true,
      showToastPreferredMessage: false,
    });
  }

  handleSetFavCharityChange(charity) {
    if (charity.nonprofit_id !== this.state.preferredCharityNpid) {
      this.setState({
        preferredCharityNpid: charity.nonprofit_id,
      });
    } else {
      this.setState({
        preferredCharityNpid: null,
      });
    }
  }

  renderCharities(charities) {
    if (this.state.selectedCharity && !this.state.showFeaturedCharities) {
      const charity = charities[this.state.selectedIndex];
      let isOpen = true;
      return (
        <>
          <MediaQuery minWidth={601}>
            <SelectedFeaturedCharity
              charity={charity}
              isCountrySetPreferredSupported={
                this.props.isCountrySetPreferredSupported
              }
              preferredCharityNpid={this.state.preferredCharityNpid}
              unifiedLoginURL={this.props.unifiedLoginURL}
              authState={this.props.authState}
              handleSetFavCharityChange={() =>
                this.handleSetFavCharityChange(charity)
              }
              handleInfoClick={() =>
                this.handleAnalyticsClick(charity, 'infoIcon')
              }
              userType={this.props.userType}
              npoBaseUrl={this.props.npoBaseUrl}
              i18n={this.props.i18n}
              amounts={this.props.amounts}
              csrf={this.props.csrf}
              handleBackNavigation={() => this.handleBackNavigation()}
              coBrand={this.props.coBrand}
              charityContent={charity.charityContent}
              enable={true}
              fptiInfo={this.props.fptiInfo}
              selectedIndex={this.state.selectedIndex}
              cdnHost={this.props.cdnHost}
              showToastPreferredMessage={this.state.showToastPreferredMessage}
            />
          </MediaQuery>
          <MediaQuery maxWidth={600}>
            <Sheet
              isOpen={isOpen}
              onClose={() => {
                this.handleBackNavigation();
                window.scrollTo(0, 0);
                return false;
              }}
              sheetProps={{
                title: `${this.props.i18n('label.donate-button')}`,
                divider: true,
              }}
            >
              <SelectedFeaturedCharity
                charity={charity}
                isCountrySetPreferredSupported={
                  this.props.isCountrySetPreferredSupported
                }
                preferredCharityNpid={this.state.preferredCharityNpid}
                unifiedLoginURL={this.props.unifiedLoginURL}
                authState={this.props.authState}
                handleSetFavCharityChange={() =>
                  this.handleSetFavCharityChange(charity)
                }
                handleInfoClick={() =>
                  this.handleAnalyticsClick(charity, 'infoIcon')
                }
                userType={this.props.userType}
                npoBaseUrl={this.props.npoBaseUrl}
                i18n={this.props.i18n}
                amounts={this.props.amounts}
                csrf={this.props.csrf}
                handleBackNavigation={() => this.handleBackNavigation()}
                coBrand={this.props.coBrand}
                charityContent={charity.charityContent}
                enable={true}
                fptiInfo={this.props.fptiInfo}
                selectedIndex={this.state.selectedIndex}
                cdnHost={this.props.cdnHost}
                showToastPreferredMessage={this.state.showToastPreferredMessage}
              />
            </Sheet>
          </MediaQuery>
        </>
      );
    } else {
      return this.renderCharityCards(charities);
    }
  }

  renderCharityCards(charities) {
    const centerAlignStyle =
      charities.length < 4 ? 'ppvx_justify-content-center' : '';
    let filteredCharities = charities;
    if (charities.length > 4 && !this.state.seeMore) {
      filteredCharities = filteredCharities.slice(0, 4);
    }
    const charityCards = filteredCharities.map((charity, index) => {
      return (
        <Col
          lg={'3'}
          md={'4'}
          sm={'6'}
          xs={'12'}
          className={styles.featuredCharityCardStyle}
          key={index}
        >
          <HubCharityCard
            charity={charity}
            isMobile={this.props.isMobile}
            causeArea={charity.cause_area}
            testId={index}
            viewCharity={() => this.handleCharityClick(charity, index)}
            handleLearnMoreClick={() =>
              this.handleAnalyticsClick(charity, 'learnMore')
            }
            i18n={this.props.i18n}
            enable={this.props.enable}
            fptiInfo={this.props.fptiInfo}
            name={charity.name}
            npid={charity.nonprofit_id}
            logo_url={charity.logo_url}
          />
        </Col>
      );
    });
    return (
      <div>
        <HeadingText as='h3' size='sm' className={styles.featuredModuleHeader}>
          {this.props.i18n('label.charity-module-title')}
        </HeadingText>
        <Row className={centerAlignStyle} align='left'>
          {charityCards}
        </Row>
        {!this.state.seeMore && charities.length > 4 && (
          <Row>
            <Col
              style={{
                textAlign: 'center',
                marginTop: '36px',
              }}
            >
              <Link
                onClick={() => this.setState({ seeMore: true })}
                tabIndex='0'
                role='link'
                style={{
                  color: v2blue400,
                }}
              >
                {this.props.i18n('label.see-more')}
              </Link>
            </Col>
          </Row>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className={styles.charityTileRow}>
        {this.renderCharities(this.props.featuredCharities)}
      </div>
    );
  }
}
